import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import Icon from '../../icon'
import Typography from '../../typography'
import PreviewTrigger from '../preview/trigger'
import Action from '../action'
import { getDuration, getModulesCount } from '../utils'

import Clock from '../../icon/clock.svg'
import Play from '../../icon/play.svg'
import Medal from '../../icon/medal.svg'

const Media = ({ course, ...attrs }) => {
  const backgroundImageUrl = get(course, 'headerImageListStandar.url', null)
  const hasPreview = get(course, 'previewVideo', null) || get(course, 'previewEmbed', null)
  return <div
    className={
      classNames([
        'relative',
        'bg-no-repeat',
        'bg-center',
        'bg-cover',
        'p-6'
      ])
    }
    style={{
      height: '12rem',
      borderRadius: '0 2.5rem 2.5rem 2.5rem',
      backgroundImage: backgroundImageUrl ? `url('${backgroundImageUrl}')` : null
    }}>
    {
      hasPreview
        ? <PreviewTrigger
          course={course}
          className={
            classNames([
              'absolute',
              'top-1/2',
              'left-1/2',
              'transform',
              '-translate-x-1/2',
              '-translate-y-1/2'
            ])
          } />
        : null
    }
  </div>
}

Media.propTypes = {
  course: PropTypes.object
}

const Body = ({ course, integrationSettings, ...attrs }) => {
  const duration = getDuration(course, true)
  const modulesCount = getModulesCount(course)

  return <div
    className={'p-4'}>
    <Action
      course={course}
      integrationSettings={integrationSettings}
      automaticRedirect="true" />
    <Typography
      size={'four'}
      weight={'bold'}
      className={'mt-6 mb-3'}
      clamp={2}>
      Informacion del curso
    </Typography>

    {
      duration
        ? <div
          className={'flex flex-row items-center mb-2'}>
          <Icon
            width={12}
            height={12}
            svg={Clock}
            className={'mr-2'} />
          <Typography
            size={'three'}
            weight={'regular'}>
            Duracion: {duration}
          </Typography>
        </div>
        : null
    }
    {
      modulesCount
        ? <div
          className={'flex flex-row items-center mb-2'}>
          <Icon
            width={12}
            height={12}
            svg={Play}
            className={'mr-2'} />
          <Typography
            size={'three'}
            weight={'regular'}>
            {modulesCount} módulos de acceso ilimitado
          </Typography>
        </div>
        : null
    }
    <div
      className={'flex flex-row items-center'}>
      <Icon
        width={12}
        height={12}
        svg={Medal}
        className={'mr-2'} />
      <Typography
        size={'three'}
        weight={'regular'}>
        Certifícate al terminar
      </Typography>
    </div>
  </div>
}

Body.propTypes = {
  course: PropTypes.object,
  integrationSettings: PropTypes.object
}

const Card = ({ course, integrationSettings, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'flex',
      'flex-col',
      'relative',
      'bg-white',
      'overflow-hidden',
      'shadow-lg'
    ]
  )

  attrs.style = {
    borderRadius: '2.5rem',
    ...attrs.style
  }

  return <div
    {...attrs}>
    <Media
      course={course} />
    <Body
      course={course}
      integrationSettings={integrationSettings} />
  </div>
}

Card.propTypes = {
  course: PropTypes.object,
  integrationSettings: PropTypes.object
}

export default Card
